export default {"src":"/_next/static/media/facebook-logo.156f7b92.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};